const getInitials = (name: string): string => {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return parts[0].substring(0, 2).toUpperCase();
};

const UserInfo = ({ user }: any) => {
    const userName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim();

    return (
        <div className="flex items-center gap-2">
            <div className="w-10 h-10 bg-blue-200 rounded-full flex items-center justify-center text-white text-base font-medium">
                {getInitials(user?.firstName + ' ' + user?.lastName)}
            </div>
            <div className="flex flex-col"> 
                {userName ? (<span className="text-sm font-medium">{userName}</span>) : <span className="text-sm font-medium text-red-500">Deleted user</span>}
                {user?.phone && <span className="text-xs text-gray-600">{user.phone}</span>}
                {user?.email && <span className="text-xs text-gray-600">{user.email}</span>}
            </div>
        </div>
    );
};

export default UserInfo;
